import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';

import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';


@Component({
  selector: 'app-documentaion-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './documentaion-custom-brand.html',
  styleUrl: './documentaion-custom-brand.scss',
})
export class DocumentaionCustomBrand {

}
